import React from 'react';
import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../stores/websocketStore/websocketProvider';

/**
 * ProtectedRoute - Wraps components that require user authentication
 * Redirects to login if user is not authenticated
 * Note: This is separate from Tradier OAuth login
 */
export const ProtectedRoute = observer(({ children }) => {
  const { userAuthStore } = useWebsocketStore();

  if (!userAuthStore.isAuthenticated) {
    // User is not authenticated, redirect to login
    return <Navigate to="/ui/login" replace />;
  }

  // User is authenticated, render the protected content
  return <>{children}</>;
});
